export class UrlBuilder {
    constructor(prefix = "#") {
        this.prefix = prefix;
    }

    replacePlaceholders(path, params) {
        if (typeof path !== "string" || !params) {
            return path;
        }

        return path.replace(/:(\w+)/g, (match, group) => {
            return params[group] || match;
        });
    }

    generateUrl(path, params) {
        const replacedPath = this.replacePlaceholders(path, params);
        const url = this.prefix + replacedPath;

        return url;
    }
}
